/**
 * admin/src/index.js
 * Entry point for the Platform Admin standalone app.
 * Only mounts: AuthProvider, ToastProvider, ErrorBoundary, and the App router.
 * No WholesalerProvider, CartProvider, ProductsProvider — those are customer-only.
 */
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { AuthProvider, ToastProvider, ErrorBoundary } from "@urbamart/shared";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <AuthProvider>
        <ToastProvider>
          <App />
        </ToastProvider>
      </AuthProvider>
    </ErrorBoundary>
  </React.StrictMode>
);
